export const EMERGENCY_CONTACTS_PERMISSION = ['resident-edit'];
